import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Rutas
import { APP_ROUTING } from './app.routing';

//http
import { HttpModule } from '@angular/http';

//Compnentes
import { AppComponent } from './app.component';
import { NavbarComponent, MenuComponent, HomeComponent,LoginComponent, FooterComponent,
         SidebarComponent, SeguimientoComponent, NotificacionesComponent, RegistroComponent } from './components/index.component';

//Servicios
import { UsuariosService, StorageService, ServicioService } from './servicios/index.service';

//Angular Maps
import { AgmCoreModule } from '@agm/core';

//Pipes
import { StatusPipe } from './pipes/statusMenu.pipe';
import { SpeedPipe } from './pipes/speed.pipe';
import { DistanciaPipe } from './pipes/distancia.pipe';
import { SelecRegistroPipe } from './pipes/selecRegistro.pipe';
import { IconoRedPipe } from './pipes/iconConectado.pipe';
import { HistorialLatPipe } from './pipes/historialLat.pipe';

//Firebase
import { firebaseConfig } from './components/Config/firebase.config';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { ServicioComponent } from './components/servicio/servicio.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { UsuarioComponent } from './components/usuario/usuario.component';

//import { Ng2MapComponent } from 'ng2-map'

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    MenuComponent,
    HomeComponent,
    LoginComponent,
    FooterComponent,
    SidebarComponent,
    SeguimientoComponent,
    ServiciosComponent,
    StatusPipe,
    SpeedPipe,
    DistanciaPipe,
    SelecRegistroPipe,
    IconoRedPipe,
    ServicioComponent,
    UsuariosComponent,
    UsuarioComponent,
    NotificacionesComponent,
    RegistroComponent,
    HistorialLatPipe
  ],
  imports: [
    BrowserModule,
    APP_ROUTING,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDPNWc3-_6mQy1f8WcShFy7GEQTppldn68',
      libraries: ["places"]
    }),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule
  ],
  providers: [
    UsuariosService,
    StorageService,
    ServicioService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/app.module.ts